import { withStyles, MenuProps as MuiMenuProps, WithStyles, Menu as MuiMenu } from '@material-ui/core';

import { styles } from './Menu.styles';

export type MenuProps = MuiMenuProps & WithStyles<typeof styles>;

export const Menu = withStyles(styles)(({ classes, ...props }: MenuProps) => <MuiMenu {...props} classes={classes} />);
